/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitMicroAuthVerificationAmount} from '../api'

export const useMutationSubmitMicroAuthVerificationAmount = createReactQueryMutationHook('submitMicroAuthVerificationAmount', submitMicroAuthVerificationAmount)
